const translations = {
  'allCourses.seo.title': 'All TEFL Courses in Barcelona, Spain by TEFL Iberia',
  'allCourses.seo.description':
    'TEFL Iberia offers a wide range of intensive TEFL Courses in Spain, to suit all budget, schedules and needs. Find out more.',
};

export default translations;
